import { Box, Button, FormField, RangeInput, Text, TextInput } from "grommet"
import { Image } from "grommet-icons"
import RangeInputWithEdit from "../../../../forms/RangeInputWithEdit"
import ButtonInput from "../../../../forms/ButtonInput"
import { useTranslation } from "react-i18next"

export const VectorSettingsForm = ({ label, title, vectorInputName, color1InputName, color2InputName, colorGradientAngleInputName, outlineWidthInputName, outlineColorInputName, category }) => {

    const { t } = useTranslation('roulette');

    return (
        <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
            <FormField 
                label={label}
                name={vectorInputName}
                className="no-border-form-field"
                component={(props) => <ButtonInput title={title} icon={<Image />} {...props} category={category} />}
            />
            <FormField label={t('color1Label')}>
                <TextInput name={color1InputName} type="color" />
            </FormField>
            <FormField label={t('color2Label')}>
                <TextInput name={color2InputName} type="color" />
            </FormField>
            <FormField label={t('angleLabel')} noBorder noFocus>
                <RangeInputWithEdit name={colorGradientAngleInputName} type="number" unit={'°'} min={0} max={360} step={1} />
            </FormField>
            <FormField label={t('outlineWidthLabel')} noBorder noFocus>
                <RangeInputWithEdit name={outlineWidthInputName} type="number" unit={'px'} min={0} max={50} step={1} />
            </FormField>
            <FormField label={t('outlineColorLabel')}>
                <TextInput name={outlineColorInputName} type="color" />
            </FormField>
        </Box>
    )
}